
import NewPayment from "../BBPSBillPayment/NewPayment";
import Inactive from "../components/Inactive";
import LogoutPage from "../components/logoutPage/LogoutPage";
import MoneySettlement from "../components/MoneySettlement";
import MoneyTransfer from "../components/MoneyTransfer";
import AddMoney from "../Matm/AddMoney";
import AddmoneyForm from "../Matm/AddmoneyForm";
import AddmoneyReports from "../Matm/AddmoneyReport";
import AddmoneyTable from "../Matm/AddmoneyTable";
import MatmBankVerification from "../pages/MatmBankVerification";
import SettlementHistory from "../Matm/SettlementHistory";
import WalletSettlement from "../Matm/WalletSettlement";
import Broadband from "../pages/Broadband";
import CreditCardSelect from "../pages/CreditCardSelect";
import Dashboard from "../pages/Dashboard";
import DTHRecharge from "../pages/DTHRecharge";
import Electricity from "../pages/Electricity";
import Fastag from "../pages/Fastag/Fastag";
import FundHistory from "../pages/FundHistory";
import LedgerHistory from "../pages/LedgerHistory";
import LpgBooking from "../pages/LpgBooking/LpgBooking";
import AddMoneyWalletLedgers from "../pages/AddMoneyWalletLedgers";
import MainWalletLedgers from "../pages/MainWalletLedgers";
import RegistrationForm from "../pages/MerchantRegistration/RegistrationForm";
import AddBeneficiaryBank from "../pages/MoneyTransfer/AddBeneficiaryBank";
import BeneficiaryForm from "../pages/MoneyTransfer/BeneficiaryForm";
import MoneyList from "../pages/MoneyTransfer/MoneyList";
import MoneyTransferDMT from "../pages/MoneyTransfer/MoneyTransferDMT";
import MoneyTransfertoBank from "../pages/MoneyTransfer/MoneyTransfertoBank";
import Password from "../pages/Password";
import Postpaid from "../pages/PostpaidMobile/Postpaid";
import MobileRecharge from "../pages/PrepaidMobile/MobileRecharge";
import ProfileDashboard from "../pages/ProfileDashboard";
import WelcomeLetter from "../components/WelcomeLetter";
import IdCard from "../components/IdCard";
import Certificate from "../components/Certificate";
import Registration from "../pages/Registration";
import SignupForm from "../pages/Signup/SignupForm";
import ResetPassword from "../pages/Signup/ResetPassword";
import NewPassword from "../pages/Signup/NewPassword";
import LoginForm from "../pages/Login/LoginForm";
import NewMpin from "../pages/Login/NewMpin";
import TeamMembers from "../pages/TeamMembers";
import TeamWallet from "../pages/TeamWallet";
import GeneratedReports from "../pages/GeneratedReports";
import RechargePayHistory from "../RechargeBills/RechargePayHistory";
import RechargePayment from "../RechargeBills/RechargePayment";
import RechargeWallet from "../RechargeBills/RechargeWallet";
import BBPSBill from "../UtilityPayments/BBPSBill";
import PaymentHistory from "../UtilityPayments/PaymentHistory";
import BBPSPayHistory from "../BBPSBillPayment/BBPSPayHistory";
import DynamicService from "../pages/services/DynamicService";
import AdminMerchantList from "../components/Super/AdminMerchantList";
import BalanceEnquiry from "../pages/Aeps/BalanceEnquiry";
import MerchantBusiness from "../pages/MerchantRegistration/MerchantBussiness";
import MiniStatement from "../pages/Aeps/MiniStatement/MiniStatement";
import AadhaarPay from "../pages/Aeps/AadhaarPay/AadhaarPay";
import Authanticate from "../pages/Aeps/Authanticate";
import AepsLedgers from "../pages/Aeps/AepsLedgers";
import AepsTxnHistory from "../pages/Aeps/AepsTxnHistory";
import AadhaarTesting from "../pages/Aeps/AadhaarTesting";
import AepsDashboard from "../pages/Aeps/AepsDashboard";
import OtpVerifyPage from "../pages/Aeps/OtpVerifyPage";
import NotFound from "../pages/NotFound";
import TxnDetailPage from "../pages/TxnDetail/TxnDetailPage";
import TeamMemberDetailPage from "../pages/TeamMemberDetail/TeamMemberDetailPage";
import PgPayout from "../pages/Finkeda/PgPayout";
import PgPayoutSelect from "../pages/Finkeda/PgPayoutSelect";
import PgPayoutV2 from "../pages/Finkeda/PgPayoutV2";
import PgPayoutHistory from "../pages/Finkeda/PgPayoutHistory";
import PaymentCallback from "../pages/Finkeda/PaymentCallback";
import DataTransfer from "../pages/DataTransfer";
export const routes = [
  { path: "/login", element: <SignupForm/>, isProtected: false },
  { path: "/reset-password", element: <ResetPassword/>, isProtected: false },
  { path: "/new-password", element: <NewPassword/>, isProtected: false },
  { path: "/signup", element: <SignupForm/>, isProtected: false },
  { path: "/logout", element: <LogoutPage/>, isProtected: true },
  { path: "/password-changes", element: <Password/>, isProtected: true },
  { path: "/verify/mpin/:username", element: <LoginForm />, isProtected: false },
{
  path: "/service/:slug",
  element: <DynamicService />,
  isProtected: true,
},
  { path: "/new-mpin", element: <NewMpin/>, isProtected: false },
  { path: "/dashboard", element: <Dashboard/>, isProtected: true },
  { path: "/", element: <Dashboard/>, isProtected: true },
   { path: "/inactive", element: <Inactive/>, isProtected: true },
  { path: "/money-settlement", element: <MoneySettlement/>, isProtected: true },
  { path: "/settalment-bank/:id", element: <MoneyTransfer/>, isProtected: true },
  { path: "/profile", element: <ProfileDashboard />, isProtected: true },
  { path: "/welcome-letter", element: <WelcomeLetter />, isProtected: true },
  { path: "/id-card", element: <IdCard />, isProtected: true },
  { path: "/certificate", element: <Certificate />, isProtected: true },
  { path: "/dth", element: <DTHRecharge />, isProtected: true },
  { path: "/electricity", element: <Electricity />, isProtected: true },
  { path: "/team", element: <TeamMembers />, isProtected: true },
  { path: "/team/member/:id", element: <TeamMemberDetailPage />, isProtected: true },
  { path: "/ledgers", element: <LedgerHistory />, isProtected: true },
  { path: "/fund/report/:id", element: <FundHistory />, isProtected: true },
  { path: "/mobile", element: <MobileRecharge />, isProtected: true },
  { path: "/register", element: <Registration />, isProtected: true },
  { path: "/merchant/:username", element: <RegistrationForm />, isProtected: true },
  { path: "/merchant-store-details/:username", element: <MerchantBusiness />, isProtected: true },
  { path: "/fastag", element: <Fastag />, isProtected: true },
  { path: "/lpg", element: <LpgBooking/>, isProtected: true },
  { path: "/broadband", element: <Broadband />, isProtected: true },
  { path: "/postpaid", element: <Postpaid />, isProtected: true },
  { path: "/credit", element: <CreditCardSelect />, isProtected: true },
  { path: "/credit/:providerCode", element: <NewPayment />, isProtected: true },

  { path: "/new-payment", element: <NewPayment />, isProtected: true },
  { path: "/new-payment/:providerCode", element: <NewPayment />, isProtected: true },

  { path: "/team-wallet", element: <TeamWallet />, isProtected: true },
  { path: "/reports", element: <GeneratedReports />, isProtected: true },
  { path: "/data-transfer", element: <DataTransfer />, isProtected: true },
  { path: "/admin/data-transfer", element: <DataTransfer />, isProtected: true },
  { path: "/money", element: <MoneyTransferDMT />, isProtected: true },
  { path: "/money-list", element: <MoneyList />, isProtected: true },
  { path: "/beneficiary/:mobile", element: <BeneficiaryForm />, isProtected: true },
  { path: "/add-beneficiary-bank/:id", element: <AddBeneficiaryBank />, isProtected: true },
  { path: "/dmt-bank/:id", element: <MoneyTransfertoBank/>, isProtected: true },
  { path: "/initiate", element: <AddMoney />, isProtected: true },
  { path: "/matm-reports", element: <AddmoneyReports/>, isProtected: true },
  { path: "/wallet-statement", element: <WalletSettlement />, isProtected: true },
  { path: "/aeps/aeps-ledgers", element: <AepsLedgers />, isProtected: true },
  { path: "/main-wallet-ledger", element: <MainWalletLedgers />, isProtected: true },
  { path: "/add-money-ledger", element: <AddMoneyWalletLedgers />, isProtected: true },
  { path: "/settlement-history", element: <SettlementHistory />, isProtected: true },
  { path: "/aeps-history", element: <AepsTxnHistory />, isProtected: true },
  { path: "/initiate/:rule",  element: <AddmoneyForm />, isProtected: true },
  { path: "/pg-payout", element: <PgPayoutSelect />, isProtected: true },
  { path: "/pg-payout/v1", element: <PgPayout />, isProtected: true },
  { path: "/pg-payout/v2", element: <PgPayoutV2 />, isProtected: true },
  { path: "/pg-payout/history", element: <PgPayoutHistory />, isProtected: true },
  { path: "/payment/callback", element: <PaymentCallback />, isProtected: false },
  // {path:"/matm-form/:rule",  element: <AddmoneyForm />, isProtected: true },
{ path: "/matm-table", element: <AddmoneyTable/>, isProtected: true },
{ path: "/matm/bank-verification", element: <MatmBankVerification />, isProtected: true },
 { path: "/bbps-bill", element: <BBPSBill/>, isProtected: true},
 { path: "/payment", element: <PaymentHistory/>, isProtected: true},
   { path: "/bbps-pay", element: <BBPSPayHistory/>, isProtected: true},
  { path: "/rec-payment", element: <RechargePayment/>, isProtected: true },
  { path: "/rec-history", element: <RechargePayHistory/>, isProtected: true },
  { path: "/rec-wallet/:category", element: <RechargeWallet />, isProtected: true },
  { path: "/txn/:type/:id", element: <TxnDetailPage />, isProtected: true },
  { path: "/super", element: <AdminMerchantList />, isProtected: true },
  { path: "/aeps/balance-enquiry", element: <BalanceEnquiry />, isProtected: true },
  { path: "/aeps/mini-statement/:username", element: <MiniStatement />, isProtected: true },
  { path: "/aeps/aadhaar-pay/:username", element: <AadhaarPay />, isProtected: true },
  { path: "/aeps/aeps-auth/:username", element: <Authanticate />, isProtected: true },
  { path: "/aeps/testing", element: <AadhaarTesting />, isProtected: true },
  { path: "/aeps/dashboard", element: <AepsDashboard />, isProtected: true },
  { path: "/aeps/otp-verify/:bank", element: <OtpVerifyPage />, isProtected: true },
  { path: "*", element: <NotFound />, isProtected: true },

];
